import { Link } from 'react-router-dom'
import { Icon } from '../components/ui/Icons'

// Pantalla pública de inicio (también start_url de la PWA). No consulta ninguna
// sesión: cada tipo de acceso resuelve la suya en su propia ruta.
const accessOptions = [
  {
    to: '/socio/login',
    icon: 'users',
    title: 'Socios',
    description: 'Accede a tu credencial, cursos y beneficios.',
    cta: 'Ingresar como socio',
    accent: 'bg-secondary',
    iconClass: 'bg-secondary/12 text-primary',
    buttonClass: 'bg-primary text-white shadow-lg shadow-primary/20 group-hover:bg-primary-hover',
  },
  {
    to: '/login',
    icon: 'dashboard',
    title: 'Directiva',
    description: 'Administración del Centro de Padres.',
    cta: 'Ingresar como directiva',
    accent: 'bg-primary',
    iconClass: 'bg-primary/10 text-primary',
    buttonClass: 'border-2 border-primary text-primary group-hover:bg-primary group-hover:text-white',
  },
]

export default function AccessSelectorPage() {
  return (
    <div className="relative min-h-dvh overflow-hidden bg-background">
      {/* Detalle institucional: franja tricolor y un leve tinte azul superior. */}
      <div className="absolute inset-x-0 top-0 flex h-1.5" aria-hidden="true"><span className="flex-1 bg-primary" /><span className="flex-1 bg-secondary" /><span className="flex-1 bg-success" /></div>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-linear-to-b from-primary/6 to-transparent" aria-hidden="true" />

      <main className="relative mx-auto flex min-h-dvh w-full max-w-3xl flex-col justify-center px-5 py-safe-page sm:px-8">
        <header className="text-center">
          <img src="/logo-cpa-transparent.png" alt="Centro de Padres y Apoderados CSPAH" width="625" height="777" className="mx-auto h-auto w-40 object-contain min-[375px]:w-44 sm:w-52 lg:w-56" />
          <h1 className="mt-6 text-3xl font-bold tracking-tight text-text-primary sm:text-4xl">Bienvenido</h1>
          <p className="mt-2 text-base text-text-secondary">Selecciona tu tipo de acceso</p>
        </header>

        <div className="mx-auto mt-8 grid w-full max-w-md gap-4 sm:mt-10 sm:max-w-none sm:grid-cols-2 sm:gap-5">
          {accessOptions.map((option) => (
            <Link key={option.to} to={option.to} className="group relative flex flex-col overflow-hidden rounded-3xl border border-border bg-surface p-5 shadow-sm shadow-primary/5 transition hover:-translate-y-0.5 hover:border-secondary/60 hover:shadow-lg hover:shadow-primary/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary sm:p-7">
              <span className={'absolute inset-x-0 top-0 h-1 ' + option.accent} aria-hidden="true" />
              <div className="flex items-center gap-4 sm:flex-col sm:items-start">
                <span className={'grid h-12 w-12 shrink-0 place-items-center rounded-2xl sm:h-14 sm:w-14 ' + option.iconClass}><Icon name={option.icon} className="h-6 w-6 sm:h-7 sm:w-7" /></span>
                <div className="min-w-0">
                  <h2 className="text-xl font-bold uppercase tracking-wide text-primary sm:text-2xl">{option.title}</h2>
                  <p className="mt-1 text-[15px] leading-snug text-text-secondary sm:mt-2 sm:text-base">{option.description}</p>
                </div>
              </div>
              <span className="min-h-5 flex-1 sm:min-h-6" aria-hidden="true" />
              <span className={'flex min-h-12 items-center justify-center gap-2 rounded-xl px-4 text-base font-semibold transition ' + option.buttonClass}>{option.cta}<Icon name="chevronRight" className="h-5 w-5" /></span>
            </Link>
          ))}
        </div>

        <p className="mx-auto mt-8 flex max-w-md flex-wrap items-center justify-center gap-x-2 text-center text-sm text-text-secondary">
          <Icon name="help" className="h-4 w-4 shrink-0" />
          <span>¿Primera vez en CSPAH?</span>
          <Link to="/ayuda" className="inline-flex min-h-11 items-center font-semibold text-primary hover:text-primary-hover hover:underline">Guía de uso e instalación →</Link>
        </p>
        <p className="mt-6 text-center text-xs text-text-secondary">Centro de Padres y Apoderados CSPAH</p>
      </main>
    </div>
  )
}
